import { Grid, List, ListItemButton, ListItemText, Paper } from "@mui/material";
import { useHistory } from "react-router-dom";
import pendingApprovalWeek from "../../models/PendingApprovalWeek";
import useLocalStorage, { STORAGE_KEYS } from "../../hooks/useLocalStorage";
import AutoCompleteUIDTO, { EMPTY_AUTOCOMPLETE } from "../../dto/AutoCompleteUIDTO";
import { Routes } from "../../types/Routes";
import OpsPanel from "../OpsPanel";
import check from "../../img/icons/fact_check.svg"

interface Props {
  rows: pendingApprovalWeek[];
}

export default function PendingWeeklyApprovalsTile({ rows }: Props) {
  const history = useHistory();
  const [, setStoredProject] = useLocalStorage<AutoCompleteUIDTO>(STORAGE_KEYS.STORED_PROJECT, EMPTY_AUTOCOMPLETE);

  const updateCurrentHistoryEntry = (project: AutoCompleteUIDTO) => {
    setStoredProject(project);
    history.replace(`${Routes.WORKLOG_REPORT}`);
  };

  return rows.length > 0 ? (
    <>
      <OpsPanel
      title="Worklogs Approval"
      actionsRequired={false}
      icon={check}
      >
        <Paper elevation={0} style={{ minHeight: "15.5em", maxHeight: "15.5em", overflow: "auto" }}>
          <List disablePadding>
            {rows.map((row, index) => (
              <Grid item direction={"column"}>
                <ListItemButton alignItems="flex-start" disableGutters dense>
                  <ListItemText
                    primary={`${row.project.label}`}
                    onClick={() => updateCurrentHistoryEntry(row.project)}
                    primaryTypographyProps={{ fontWeight: "bold" }}
                  />
                </ListItemButton>
                <Grid item direction={"column"}>
                  {row.pendingWeeks.map((element: string) => {
                    return element.length > 0 ? (
                      <li>
                        <ListItemText secondary={`- ${element}`} />
                      </li>
                    ) : null;
                  })}
                </Grid>
              </Grid>
            ))}
          </List>
        </Paper>
      </OpsPanel>
    </>
  ) : null;
}
